import React from 'react';
import '../styles/WhatWeDo.css';
import { PageHeader } from '../components';

const WhatWeDo: React.FC = () => {
  return (
    <div className="what-we-do">
      <PageHeader title="What We Do" />
      <div className="what-we-do-container">
        
        
        <div className="what-we-do-content">
          <section className="what-we-do-section">
            <h2>Comprehensive Water & Wastewater Solutions</h2>
            <p>
              At Wasser, we offer a comprehensive portfolio of water and wastewater treatment solutions customized for Indian industrial and municipal sectors. Our services include:
            </p>
          </section>
          
          <section className="what-we-do-section">
            <h2>Our Services</h2>
            <div className="services-grid">
              <div className="service-item">
                <h3>Water Treatment Plants (WTPs)</h3>
                <p>Advanced water treatment systems designed to meet industrial and municipal water quality requirements.</p>
              </div>
              <div className="service-item">
                <h3>Effluent & Sewage Treatment Plants (ETPs/STPs)</h3>
                <p>Comprehensive wastewater treatment solutions for efficient and compliant discharge management.</p>
              </div>
              <div className="service-item">
                <h3>Zero Liquid Discharge (ZLD) Systems</h3>
                <p>Cutting-edge ZLD technology to achieve complete water recovery and eliminate liquid waste discharge.</p>
              </div>
              <div className="service-item">
                <h3>RO, DM, UF & Filtration Units</h3>
                <p>Reverse Osmosis, Demineralization, Ultrafiltration, and advanced filtration systems for water purification.</p>
              </div>
              <div className="service-item">
                <h3>Operation & Maintenance Services</h3>
                <p>Comprehensive O&M services ensuring optimal system performance and regulatory compliance.</p>
              </div>
              <div className="service-item">
                <h3>SANYOL® WT Specialty Chemicals</h3>
                <p>High-quality specialty chemicals specifically formulated for water treatment applications.</p>
              </div>
              <div className="service-item">
                <h3>Design & Engineering Consultancy</h3>
                <p>Expert consultation and engineering design services for optimal water treatment system solutions.</p>
              </div>
              <div className="service-item">
                <h3>Revamping and Retrofitting</h3>
                <p>Upgrading and modernizing existing water treatment systems for improved efficiency and performance.</p>
              </div>
            </div>
          </section>
          
          <section className="what-we-do-section">
            <h2>Our Commitment</h2>
            <p>
              We focus on maximizing water efficiency, minimizing waste, and meeting all CPCB and state pollution control board norms through proven technologies and field expertise.
            </p>
            <ul className="commitment-list">
              <li>Maximizing water efficiency across all applications</li>
              <li>Minimizing waste through innovative treatment solutions</li>
              <li>Meeting CPCB and state pollution control board norms</li>
              <li>Implementing proven technologies with field expertise</li>
              <li>Ensuring sustainable water management practices</li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
};

export default WhatWeDo;
